// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.services {
  background: var(--bg-secondary);
}

.services__header {
  text-align: center;
  margin-bottom: 64px;
}

.section__title {
  font-size: 48px;
  font-weight: 800;
  margin-bottom: 16px;
  color: var(--text-primary);
}

.section__subtitle {
  font-size: 20px;
  color: var(--text-secondary);
  max-width: 600px;
  margin: 0 auto;
}

.services__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 32px;
}

.service-card {
  background: white;
  border-radius: 16px;
  padding: 32px;
  border: 2px solid var(--border-color);
  transition: all 0.3s;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

.service-card:hover {
  border-color: var(--primary-color);
  transform: translateY(-4px);
  box-shadow: var(--shadow-lg);
}

.service-card--active {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1);
}

.service-card__icon {
  font-size: 48px;
  margin-bottom: 24px;
}

.service-card__title {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 12px;
  color: var(--text-primary);
}

.service-card__description {
  font-size: 16px;
  line-height: 1.6;
  color: var(--text-secondary);
  margin-bottom: 24px;
  flex-grow: 1;
}

.service-card__features {
  margin-bottom: 24px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  font-size: 14px;
  color: var(--text-secondary);
}

.feature-check {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(99, 102, 241, 0.1);
  color: var(--primary-color);
  border-radius: 50%;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.service-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 24px;
  border-top: 1px solid var(--border-color);
}

.service-card__price {
  font-size: 24px;
  font-weight: 700;
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

@media (max-width: 768px) {
  .section__title {
    font-size: 36px;
  }

  .section__subtitle {
    font-size: 18px;
  }

  .services__grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .service-card {
    padding: 24px;
  }

  .service-card__footer {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }

  .service-card__footer .btn {
    width: 100%;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Services/Services.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iFAAiF;EACjF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".services {\r\n  background: var(--bg-secondary);\r\n}\r\n\r\n.services__header {\r\n  text-align: center;\r\n  margin-bottom: 64px;\r\n}\r\n\r\n.section__title {\r\n  font-size: 48px;\r\n  font-weight: 800;\r\n  margin-bottom: 16px;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.section__subtitle {\r\n  font-size: 20px;\r\n  color: var(--text-secondary);\r\n  max-width: 600px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.services__grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\r\n  gap: 32px;\r\n}\r\n\r\n.service-card {\r\n  background: white;\r\n  border-radius: 16px;\r\n  padding: 32px;\r\n  border: 2px solid var(--border-color);\r\n  transition: all 0.3s;\r\n  cursor: pointer;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.service-card:hover {\r\n  border-color: var(--primary-color);\r\n  transform: translateY(-4px);\r\n  box-shadow: var(--shadow-lg);\r\n}\r\n\r\n.service-card--active {\r\n  border-color: var(--primary-color);\r\n  box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1);\r\n}\r\n\r\n.service-card__icon {\r\n  font-size: 48px;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.service-card__title {\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  margin-bottom: 12px;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.service-card__description {\r\n  font-size: 16px;\r\n  line-height: 1.6;\r\n  color: var(--text-secondary);\r\n  margin-bottom: 24px;\r\n  flex-grow: 1;\r\n}\r\n\r\n.service-card__features {\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.feature-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 8px 0;\r\n  font-size: 14px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.feature-check {\r\n  width: 20px;\r\n  height: 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: rgba(99, 102, 241, 0.1);\r\n  color: var(--primary-color);\r\n  border-radius: 50%;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.service-card__footer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding-top: 24px;\r\n  border-top: 1px solid var(--border-color);\r\n}\r\n\r\n.service-card__price {\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .section__title {\r\n    font-size: 36px;\r\n  }\r\n\r\n  .section__subtitle {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .services__grid {\r\n    grid-template-columns: 1fr;\r\n    gap: 24px;\r\n  }\r\n\r\n  .service-card {\r\n    padding: 24px;\r\n  }\r\n\r\n  .service-card__footer {\r\n    flex-direction: column;\r\n    gap: 16px;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .service-card__footer .btn {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
